export class TermsFilters {
    constructor() {
        this.filtersEl = document.querySelector('.terms-side-nav');
        if (!this.filtersEl) {
            // If the element doesn't exist, don't attempt to initialize filters
            return;
        }
        this.initializeMobileFilters();
    }

    initializeMobileFilters = () => {
        this.filtersEl.classList.add('mobile-terms-hidden');
        document.querySelector('.mobile-terms-button')?.addEventListener('click', this.toggleMobileFilters);
        document.querySelector('.close-terms-button')?.addEventListener('click', this.toggleMobileFilters);
    }

    toggleMobileFilters = () => {
        const filtersButton = document.querySelector('.mobile-terms-button');
        const filtersButtonClose = document.querySelector('.close-terms-button');
        
        // Toggle the filters' visibility
        const isFiltersShown = this.filtersEl.classList.toggle('mobile-terms-shown');
        this.filtersEl.classList.toggle('mobile-terms-hidden', !isFiltersShown);
    
        // Toggle the button's state based on the filters' visibility
        if (filtersButton && filtersButtonClose) {
            filtersButton.classList.toggle('terms-open', isFiltersShown);
            filtersButtonClose.classList.toggle('terms-open', isFiltersShown);
        }
    }
}

new TermsFilters();
